module.exports = require("././angular-animate.js");


//////////////////
// WEBPACK FOOTER
// angular-animate (bower component)
// module id = 1076
// module chunks = 1